module.exports = __webpack_public_path__ + "images/Duco_Gradient.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/Duco_Gradient.jpg
// module id = 30
// module chunks = 0